<mobi-content-section
  [id]="id() || null"
  [content]="layout"
  [box]="box()"
  [width]="hasText() && ['left', 'right'].includes(position()) ? 'lg' : layoutWidth()"
>
  <ng-template #layout>
    <div
      [class]="{
        'mobi-ui-grid': ['left', 'right'].includes(position()),
        'smMax:!gap-y-0': ['left', 'right'].includes(position()),
        'heading-spacing-before': ['left', 'right'].includes(position()) && !box(),
        'media-reverse': position() === 'left',
        'is-align-start': hasContent(),
        'is-align-center': !hasContent(),
      }"
    >
      @if (hasText() || hasContent()) {
        <div
          class="media-layout-text-wrapper self-stretch"
          [class]="{
            'mobi-ui-col-1/1': ['left', 'right'].includes(position()),
            'justify-end': position() === 'left',
            'sm:mobi-ui-col-2/3':
              ['left', 'right'].includes(position()) && layoutWidth() === 'sm',
            'sm:mobi-ui-col-1/2':
              ['left', 'right'].includes(position()) && layoutWidth() === 'lg',
            'sm:mobi-ui-col-1/3':
              ['left', 'right'].includes(position()) && layoutWidth() === 'full',
          }"
        >
          @if (title()) {
            <mobi-heading-select
              class="block"
              [title]="title()"
              [headingType]="titleSize()"
              [headingStyle]="titleSize()"
            />
          }
          <!-- NOTE: to avoid migration issues, we kept the key for the option 'oben' as 'bottom'. the new option 'unten' has the key 'below' -->
          @if (text() && position() !== 'bottom') {
            <div class="mobi-ui-margin-b-md">
              @if (text()) {
                <mobi-text class="text-read block" [data]="text()" />
              }
              @if (hasContent()) {
                <ng-container [ngTemplateOutlet]="content()"></ng-container>
              }
            </div>
          }
        </div>
      }
      <div
        [ngClass]="{
          'mobi-ui-col-1/1': ['left', 'right'].includes(position()),
          'sm:mobi-ui-col-1/3':
            hasText() && ['left', 'right'].includes(position()) && layoutWidth() === 'sm',
          'sm:mobi-ui-col-1/2':
            hasText() && ['left', 'right'].includes(position()) && layoutWidth() === 'lg',
          'sm:mobi-ui-col-2/3':
            hasText() &&
            ['left', 'right'].includes(position()) &&
            layoutWidth() === 'full',
          'sm:!mt-12': hasContent(),
        }"
      >
        <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
        <ng-content /><ng-container [ngTemplateOutlet]="media()"></ng-container>
      </div>
      <!-- NOTE: to avoid migration issues, we kept the key for the option 'oben' as 'bottom'. the new option 'unten' has the key 'below'. -->
      @if ((text() || hasContent()) && position() === 'bottom') {
        <div
          class="self-stretch"
          [class]="{
            'mobi-ui-col-1/1': ['left', 'right'].includes(position()),
            'mobi-ui-margin-t-md':
              !['left', 'right'].includes(position()) && (hasContent() || text()),
          }"
        >
          @if (text()) {
            <mobi-text class="text-read block" [data]="text()" />
          }
          @if (hasContent()) {
            <ng-container [ngTemplateOutlet]="content()"></ng-container>
          }
        </div>
      }
    </div>
  </ng-template>
</mobi-content-section>
